import { render, staticRenderFns } from "./search.vue?vue&type=template&id=f6f8cd58&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f8cd58')) {
      api.createRecord('f6f8cd58', component.options)
    } else {
      api.reload('f6f8cd58', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=f6f8cd58&", function () {
      api.rerender('f6f8cd58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/search.vue"
export default component.exports